import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
export var campaignAlertsAdapter = createEntityAdapter({});
export var campaignAlertsSlice = createSlice({
    name: 'campaignAlerts',
    initialState: campaignAlertsAdapter.getInitialState(),
    reducers: {
        campaignAlertsFetched: function(state, param) {
            var alerts = param.payload.alerts;
            campaignAlertsAdapter.upsertMany(state, alerts);
        }
    }
});
